// extracted by mini-css-extract-plugin
module.exports = {"sWhyToUseCard":"sWhyToUseCard_sWhyToUseCard__N0Pf_"};